import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash';
export default {
    namespaced: true,
    state: {
      users: [],
      status: false,
    },
    mutations: {
        setUsers(state: any, result: any) {
            state.users = result;
        },
        setStatus(state: any, result: boolean){
            state.status = result;
        }
    },
    actions: {
        async getUsers({commit}: any) {
            const allUsers = (await firebase.database().ref('users').orderByChild('company').equalTo('-Kyyp6-gT5bV22HH19Tp').once('value')).val();
            const users = [];
            for(const x in allUsers){
                allUsers[x].name = allUsers[x].firstname+' '+allUsers[x].lastname;
                users.push(allUsers[x]);
            }
            commit('setUsers', users);
        },
        resetUsers({commit}: any,row: any){
            firebase.database().ref(`reset_user`).push({
                email:row.email,
            }).then(()=>{
                commit('setStatus',true);
            });
        },
    },
    getters: {
        users: (state: any) => {
            return state.users;
        },
        status: (state: any) => {
            return state.status;
        },
    },
  };
